module.exports = __webpack_public_path__ + "media/images/icons/edit_photos-8fa43fd63a11a5c3c841868ab552ea46.svg";